<template>
	<v-badge v-bind="$attrs" :model-value="visible">
		<slot></slot>
		<template v-if="$slots.badge" #badge>
			<slot name="badge"></slot>
		</template>
	</v-badge>
</template>

<script>
export default {
	name: 'BaseBadge',
	props: {
		visible: { type: Boolean, default: false },
	},
}
</script>

<style></style>
